<template>
  <input
    type="checkbox"
    class="border-none bg-ontick-steel-300 dark:bg-ontick-carbon-500"
    :class="disabled ? 'cursor-no-drop' : 'cursor-pointer'"
    @click="$emit('toggle')"
    :checked="active"
    :disabled="disabled"
    v-model="active"
  />
</template>

<script>
export default {
  name: "ontick-switch",
  props: {
    active: {
      type: Boolean,
    },
    disabled: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
input[type="checkbox"] {
  position: relative;
  width: 40px;
  height: 20px;
  -webkit-appearance: none;
  outline: none;
  border-radius: 20px;
  box-shadow: inset 0 0 5px var(--ontick-switch-opacity);
  transition: background 300ms linear;
}
input:checked[type="checkbox"] {
  background: #19d684;
}
input[type="checkbox"]::before {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  border-radius: 20px;
  top: 0;
  left: 0;
  background: #fff;
  transform: scale(1.1);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
  transition: left 300ms linear;
}
input:checked[type="checkbox"]::before {
  left: 20px;
}
</style>
